import React, { useState, useEffect, useRef } from "react";
import { useWatchState, useModal } from "@/store";
import { BaseService } from "@/service";
import { Modal, Button, Form, message, Input, Table, Popconfirm } from "antd";
import { checkResult } from "@/common";
import { contrastOldObject } from "@/utils";

const { TextArea } = Input;
const TABLE_NAME = "thtt_organization_group";
const NAME = "orgGroupAdmin";

const App = (props) => {

    const [loading, setLoading] = useState(false);
    const [orgGroups, setOrgGroups] = useState([]);
    const [orgGroupModal, orgGroupItemModal] = useModal(["orgGroup", "orgGroupItem"]);

    const modal = useRef();

    const [[{ title = "机构群组管理", show, hide, width = 800, callback }]] = useWatchState(["modal." + NAME]);

    useEffect(() => {
        if (show) {
            getOrgGroups();
        }
    }, [show])

    const getOrgGroups = () => {
        BaseService.list({
            table: "thtt_organization_group",
            where: {
                is_delete: 0
            },
            order: ["add_time DESC"],
            process: {
                name: "items",
                key: "id",
                targetKey: "org_group_id",
                params: {
                    table: "thtt_organization_group_item",
                }
            }
        }).then(res => {
            if (!checkResult(res)) return;
            setOrgGroups(res.data.result)
        })
    }

    const onDelete = id => {
        BaseService.del({
            table: "thtt_organization_group",
            where: { id }
        }).then(res => {
            if (!checkResult(res)) return;
            getOrgGroups();
        })
    }

    const onUpdate = vo => {
        orgGroupModal.show({ state: "put", vo, callback: getOrgGroups, contrast: contrastOldObject(vo) });
    }
    const onChangeItem = orgGroupId => {
        orgGroupItemModal.show({ orgGroupId, callback: getOrgGroups });
    }
    const onAddOrgGroup = () => {
        orgGroupModal.show({ state: "add", callback: getOrgGroups });
    }

    const columns = [
        {
            title: "群组名",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "备注",
            dataIndex: "remark",
            key: "remark",
        },
        {
            title: "成员数",
            dataIndex: "items",
            key: "items",
            render: (items = []) => items.length
        },
        {
            title: "创建时间",
            dataIndex: "add_time",
            key: "add_time",
            render: time => new Date(time * 1000).format("yyyy-MM-dd")
        },
        {
            title: "操作",
            key: "action",
            width: 170,
            render: vo => (
                <span className="child-left-sm">
                    <a onClick={onDelete.later(vo.id)} className="dark-second link">删除</a>
                    <a className="dark-second link" onClick={onUpdate.later(vo)}>编辑</a>
                    <a className="dark-second link" onClick={onChangeItem.later(vo.id)}>设置成员</a>
                    {/* <Popconfirm getPopupContainer={() => document.getElementById("orgGroupAdminModal")} placement="top" title={"确认删除此申请？"} onConfirm={onDelete.later(vo.id)} okText="确认" cancelText="取消"> */}
                    {/* </Popconfirm> */}
                </span>
            )
        }
    ];

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <div id="orgGroupAdminModal">
                <div>
                    <span></span>
                    <div>
                        <Button onClick={onAddOrgGroup}>新建群组</Button>
                    </div>
                </div>
                <Table
                    className="self-top--little"
                    columns={columns}
                    // onChange={datasControl.go.filterProps("current")}
                    pagination={false}
                    dataSource={orgGroups}
                // pagination={{ total: datas.total, defaultCurrent: 1, showQuickJumper: true }}
                // expandedRowRender={expandedRowRender}
                />
            </div>
        </Modal>
    );
}

export default App;